import { globalGtm } from "@2u-landing-pages/constants";
import cohesion from "@2u-landing-pages/constants/cohesion";
import Script from "next/script";
import React from "react";

interface GoogleTagsSnippetProps {
  gtagId?: string;
  lob?: string;
  school?: string;
  program?: string;
}

const getId = (data: GoogleTagsSnippetProps) => {
  const { gtagId, lob = "", school = "", program = "" } = data;
  return gtagId || globalGtm[lob as keyof typeof globalGtm] || cohesion.make[lob]?.[school]?.[program]?.gtagId || "";
};

export const GoogleTagsSnippet: React.FC<GoogleTagsSnippetProps> = (props) => {
  const id = getId(props);

  if (!id) return null;

  return (
    <Script id="google-tags">
      {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
      `}
    </Script>
  );
};

export const GoogleTagsPixel: React.FC<GoogleTagsSnippetProps> = (props) => {
  const id = getId(props);

  if (!id) return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${id}`}
        height="0"
        width="0"
        style={{
          display: "none",
          visibility: "hidden",
        }}
      />
    </noscript>
  );
};
